import { html } from '@webtides/element-js';
import { reCaptchaStore } from '../capture-field/ReCaptchaStore';

export function templateInputElement(input, error = '') {
    if (input.type === 'checkbox') {
        return html`
            <checkbox-field
                label-screen-reader-only="true"
                label="${input.label}"
                class="form-field"
                type="checkbox"
                name="${input.name}"
                required="${input.required ?? false}"
                value="${input.value ?? true}"
            ></checkbox-field>
        `;
    }

    if (input.type === 'radioGroup') {
        return [
            html` <div class="font-bold mb-2">${input.label}</div> `,
            input.options.map(
                option => html`
                    <radio-field
                        label="${option.label}"
                        class="form-field"
                        name="${input.name}"
                        value="${option.value ?? ''}"
                        required="${input.required ?? false}"
                        checked="${option.checked ? 'false' : 'true'}"
                    ></radio-field>
                `
            ),
        ];
    }

    if (input.type === 'hidden') {
        return html` <input type="${input.type ?? 'text'}" name="${input.name}" value="${input.value ?? ''}" /> `;
    }

    if (input.type === 'conditional-fields') {
        return html` <conditional-fields fields="${JSON.stringify(input.fields)}"></conditional-fields> `;
    }

    return html`
        <input-field
            label="${input.label}"
            placeholder="${input.label}"
            class="form-field"
            type="${input.type ?? 'text'}"
            name="${input.name}"
            value="${input.value ?? ''}"
            required="${input.required ?? false}"
        ></input-field>
    `;
}

export default function templateInput(input, errorMessage) {
    if (input.type === 'hidden') {
        return html`${templateInputElement(input)}`;
    } else if (input.type === 'reCaptcha') {
        if (!reCaptchaStore.enabled) return null;
        return html` <div class="${input.cssClass ?? 'col-span-12'}">
            <recaptcha-field
                ref="captcha"
                intercept-submit="false"
                validation-state="${errorMessage}"
            ></recaptcha-field>
        </div>`;
    } else {
        return html`
            <div class="${input.cssClass ?? 'col-span-12'}">
                ${templateInputElement(input)}
                ${errorMessage ? html`<div class="mt-1 text-sm text-danger-500">${errorMessage}</div>` : html``}
            </div>
        `;
    }
}
